import * as React from 'react';
import { SVGProps } from 'react';

const SvgNotFound = (props: SVGProps<SVGSVGElement>) => (
  <svg width={150} height={150} viewBox="0 0 150 150" fill="none" role="img" {...props}>
    <circle cx={75} cy={90} r={60} fill="#EAEAF0" />
    <rect
      x={50}
      y={74}
      width={92}
      height={60}
      rx={4}
      fill="#E9F9FB"
      stroke="currentColor"
      strokeWidth={3}
    />
    <path
      d="M51.438 127.906h89.124v2.188a2.5 2.5 0 0 1-2.5 2.5H53.937a2.5 2.5 0 0 1-2.5-2.5v-2.188Z"
      fill="#6AD5E5"
    />
    <rect x={106} y={94} width={22} height={5} rx={2.5} fill="currentColor" />
    <rect x={78} y={94} width={22} height={5} rx={2.5} fill="currentColor" />
    <rect x={106} y={111} width={22} height={5} rx={2.5} fill="currentColor" />
    <rect x={78} y={111} width={22} height={5} rx={2.5} fill="currentColor" />
    <rect x={62} y={91} width={10} height={10} rx={5} fill="#FF4496" />
    <rect x={62} y={108} width={10} height={10} rx={5} fill="#FF4496" />
    <path
      d="M56.5 82s-3.167 28.833-4.5 40.5l-2 1V76l89.5-1.5 2 1.5c-28.5 1.5-85 6-85 6Z"
      fill="#fff"
    />
    <rect x={50} y={74} width={92} height={60} rx={4} stroke="currentColor" strokeWidth={3} />
    <circle cx={75.891} cy={47.44} r={35} fill="#fff" />
    <rect
      x={59.773}
      y={60.461}
      width={40.25}
      height={6}
      rx={3}
      transform="rotate(-45 59.773 60.461)"
      fill="#6AD5E5"
    />
    <rect
      x={64.016}
      y={32.461}
      width={40.25}
      height={6}
      rx={3}
      transform="rotate(45 64.016 32.461)"
      fill="#6AD5E5"
    />
    <path
      d="M75.574 86.65c-9.862 0-19.724-3.764-27.234-11.295-15.019-15.061-15.019-39.558 0-54.62 15.02-15.06 39.448-15.06 54.467 0 15.019 15.062 15.019 39.559 0 54.62-7.464 7.53-17.371 11.296-27.233 11.296Zm0-72.674c-8.686 0-17.417 3.312-24.022 9.98-13.255 13.293-13.255 34.886 0 48.178 13.255 13.292 34.788 13.292 48.043 0 6.424-6.442 9.953-14.97 9.953-24.089 0-9.118-3.529-17.647-9.953-24.088a33.828 33.828 0 0 0-24.021-9.98Z"
      fill="currentColor"
    />
    <path
      d="M17.171 108.925a2.295 2.295 0 0 1-1.628-.68c-.905-.908-.905-2.359 0-3.221l32.797-32.89c.905-.907 2.353-.907 3.212 0 .905.907.905 2.36 0 3.221l-32.797 32.89c-.408.453-.996.68-1.584.68Z"
      fill="currentColor"
    />
    <path
      d="M37.935 85.834c2.489 2.495 2.489 6.533 0 8.983l-20.221 20.278c-2.488 2.495-6.514 2.495-8.957 0-2.488-2.495-2.488-6.533 0-8.983l20.176-20.278a6.35 6.35 0 0 1 9.002 0Z"
      fill="#6AD5E5"
    />
    <path d="M27.307 87.487 23.404 91.4l8.957 8.982 3.903-3.913-8.957-8.982Z" fill="currentColor" />
  </svg>
);

export default SvgNotFound;
